/* =============================================================================
   Mogadoro theme
   No dependencies. Everything degrades to a working, readable page without it.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.__moneyFormat || '${{amount}}')
      : '$' + (cents / 100).toFixed(2);
  };
  var priceFor = function (el, v, which) {
  try {
    var root = el.closest('[data-product-root]');
    var src = root && root.querySelector('[data-price-json]');
    var m = src && JSON.parse(src.textContent)[v.id];
    if (m) { var s = which === 'compare' ? m.compare : m.price; if (s) return s; }
  } catch (e) {}
  return money(which === 'compare' ? v.compare_at_price : v.price);
};
function announce(msg) { var l = $('#a11y-live'); if (l) l.textContent = msg; }

  /* ------------------------------------------------------------ reveals */
  function reveals() {
    if (!document.body.classList.contains('motion-reveals') || REDUCED) {
      $$('.rv').forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8%' });
    $$('.rv:not(.in)').forEach(function (e) { io.observe(e); });
  }

  /* --------------------------------------------- header + hero parallax */
  function chrome() {
    var hd = $('.hd'), px = $('[data-parallax]'), sb = $('#sb'), tick = false;
    if (!hd && !px && !sb) return;
    var doPx = px && document.body.classList.contains('motion-parallax') && !REDUCED;
    window.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (hd) hd.classList.toggle('stuck', y > 10);
        if (doPx && y < 900) px.style.transform = 'translate3d(0,' + (y * 0.28) + 'px,0)';
        if (sb) sb.classList.toggle('on', y > 520);
        tick = false;
      });
    }, { passive: true });
  }

  /* ------------------------------------------------------- 360 viewer
     One instance per mount point. Never cloned — a clone loses its
     listeners and the viewer silently dies. */
  function initSpin(root, dotsEl, frames) {
    if (!root || !frames.length) return null;
    root.classList.add('loading');
    root.tabIndex = 0;
    root.setAttribute('role', 'img');
    root.setAttribute('aria-label', root.getAttribute('data-label') || '360 degree view. Drag, or use the arrow keys, to rotate.');

    var imgs = frames.map(function (src, i) {
      var im = new Image();
      im.decoding = 'async'; im.alt = ''; im.draggable = false;
      if (i === 0) im.className = 'on';
      root.appendChild(im);
      if (dotsEl) { var d = document.createElement('i'); if (i === 0) d.className = 'on'; dotsEl.appendChild(d); }
      return im;
    });
    var dots = dotsEl ? $$('i', dotsEl) : [];
    var fi = 0, down = false, lastX = 0, acc = 0, auto = null,
        ready = false, used = false, onScreen = false, fetching = false;

    function setF(n) {
      fi = ((n % frames.length) + frames.length) % frames.length;
      imgs.forEach(function (im, i) { im.classList.toggle('on', i === fi); });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === fi); });
    }
    /* a full-width sweep turns it about one and a half times, at any frame count */
    function step() { return Math.max(10, root.clientWidth / (frames.length * 1.5)); }
    function stopAuto() { if (auto) { clearInterval(auto); auto = null; } }
    function startAuto() {
      if (auto || used || REDUCED || !ready || !onScreen || root.closest('[hidden]')) return;
      auto = setInterval(function () { if (!down) setF(fi + 1); }, 1500);
    }
    function touched() { used = true; stopAuto(); root.classList.add('used'); }
    function begin(x) { down = true; lastX = x; acc = 0; touched(); root.classList.add('drag'); }
    function drag(x) {
      if (!down) return;
      acc += x - lastX; lastX = x;
      var s = step();
      while (Math.abs(acc) >= s) { setF(fi + (acc > 0 ? 1 : -1)); acc -= (acc > 0 ? 1 : -1) * s; }
    }
    function stop() { down = false; acc = 0; root.classList.remove('drag'); }

    root.addEventListener('pointerdown', function (e) {
      if (e.button && e.button !== 0) return;
      try { root.setPointerCapture(e.pointerId); } catch (_) {}
      begin(e.clientX);
    });
    root.addEventListener('pointermove', function (e) { drag(e.clientX); });
    root.addEventListener('pointerup', stop);
    root.addEventListener('pointercancel', stop);
    root.addEventListener('lostpointercapture', stop);
    root.addEventListener('dragstart', function (e) { e.preventDefault(); });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault(); touched(); setF(fi + (e.key === 'ArrowRight' ? 1 : -1));
    });
    root.addEventListener('pointerenter', stopAuto);
    root.addEventListener('pointerleave', function () { stop(); startAuto(); });

    function load() {
      if (fetching) return; fetching = true;
      imgs.forEach(function (im, i) { im.src = frames[i]; });
      Promise.all(imgs.map(function (im) {
        return im.decode ? im.decode().catch(function () {}) : Promise.resolve();
      })).then(function () { ready = true; root.classList.remove('loading'); startAuto(); });
    }
    new IntersectionObserver(function (es, o) {
      es.forEach(function (e) { if (e.isIntersecting) { load(); o.disconnect(); } });
    }, { rootMargin: '500px' }).observe(root);
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { onScreen = e.isIntersecting; onScreen ? startAuto() : stopAuto(); });
    }, { threshold: 0.25 }).observe(root);

    return { load: load, startAuto: startAuto, stopAuto: stopAuto, setFrame: setF };
  }

  function spins() {
    $$('[data-spin]').forEach(function (root) {
      var frames;
      try { frames = JSON.parse(root.getAttribute('data-spin')); } catch (e) { frames = []; }
      var dots = root.parentNode.querySelector('.dots');
      root.__spin = initSpin(root, dots, frames);
    });
  }

  /* ------------------------------------------------ product media tabs */
  function mediaTabs() {
    $$('[data-media-tabs]').forEach(function (wrap) {
      var views = $$('.gal-view', wrap);
      $$('.tog button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-view');
          $$('.tog button', wrap).forEach(function (x) { x.setAttribute('aria-current', x === b); });
          views.forEach(function (p) { p.hidden = p.getAttribute('data-view') !== v; });
          var sp = wrap.querySelector('[data-spin]');
          if (sp && sp.__spin) { v === 'spin' ? (sp.__spin.load(), sp.__spin.startAuto()) : sp.__spin.stopAuto(); }
        });
      });
    });
  }

  /* --------------------------------------------------------- gallery */
  function gallery() {
    var gm = $('#galMain'), gt = $('#galThumbs');
    if (!gm || !gt) return;
    var imgs = $$('img', gm);
    $$('button', gt).forEach(function (b, i) {
      b.addEventListener('click', function () {
        imgs.forEach(function (x, j) { x.style.opacity = j === i ? 1 : 0; });
        $$('button', gt).forEach(function (x, j) { x.setAttribute('aria-current', j === i); });
      });
    });
  }

  /* ------------------------------------------------------- film band */
  function films() {
    $$('[data-films]').forEach(function (band) {
      var stage = $('.film-v', band), strip = $('.film-strip', band), cap = $('.film-cap', band);
      if (!stage || !strip) return;
      /* read the films off the strip buttons — no JSON to escape through Liquid */
      var list = $$('button', strip).map(function (b) {
        return {
          src: b.getAttribute('data-src'),
          poster: b.getAttribute('data-poster'),
          label: b.getAttribute('data-label'),
          href: b.getAttribute('data-href')
        };
      }).filter(function (f) { return f.src; });
      if (!list.length) { band.hidden = true; return; }
      if (list.length < 2) strip.hidden = true;
      var vid = document.createElement('video');
      vid.muted = true; vid.loop = true; vid.playsInline = true;
      vid.setAttribute('playsinline', ''); vid.setAttribute('muted', '');
      vid.preload = 'none';
      stage.appendChild(vid);
      var started = false;

      function show(i) {
        var f = list[i];
        if (strip) $$('button', strip).forEach(function (b, j) { b.setAttribute('aria-current', j === i); });
        if (cap) cap.textContent = f.label || '';
        vid.classList.remove('on');
        /* the still sits behind the video, so a slow or blocked file still leaves a picture */
        if (f.poster) { stage.style.backgroundImage = 'url("' + f.poster + '")'; vid.poster = f.poster; }
        vid.src = f.src;
        if (REDUCED) return;
        var go = function () { vid.classList.add('on'); vid.play().catch(function () {}); };
        vid.readyState >= 2 ? go() : vid.addEventListener('loadeddata', go, { once: true });
      }
      if (strip) {
        strip.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          started = true; show(+b.getAttribute('data-i'));
        });
      }
      if (list[0].poster) stage.style.backgroundImage = 'url("' + list[0].poster + '")';
      if (cap) cap.textContent = list[0].label || '';
      /* each film is over a megabyte — nothing is fetched until the band is reached */
      new IntersectionObserver(function (es, o) {
        es.forEach(function (e) { if (e.isIntersecting && !started) { started = true; show(0); o.disconnect(); } });
      }, { threshold: 0.2 }).observe(stage);
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!vid.src) return;
          e.isIntersecting ? vid.play().catch(function () {}) : vid.pause();
        });
      }, { threshold: 0.15 }).observe(stage);
    });
  }

  /* ------------------------------------------------ reviews carousel
     Scrolls by a full view, not by a card, so nothing is ever half shown.
     Everything here is an enhancement: with JS off the track is still a
     native horizontal scroller and every review is still readable. */
  function reviews() {
    $$('[data-reviews]').forEach(function (root) {
      var track = $('[data-rev-track]', root);
      if (!track || track.getAttribute('data-rev-on')) return;
      track.setAttribute('data-rev-on', '1');

      var cards = $$('.rev', track);
      if (!cards.length) return;

      var nav = $('[data-rev-nav]', root),
          prev = $('[data-rev-prev]', root),
          next = $('[data-rev-next]', root),
          dots = $('[data-rev-dots]', root);
      var bar = null, timer = null, stopped = false;
      var every = parseInt(root.getAttribute('data-autoplay'), 10) || 0;

      /* Measured off the cards, never off clientWidth. A view is a whole
         number of cards, and 12 cards three at a time is four pages — divide
         the scroll width instead and the gaps add up to a fifth page that is
         77px wide, which is where stray dots and a dead last arrow come from. */
      function step() {
        var a = cards[0], b = cards[1];
        var cw = a.offsetWidth || 1;
        var gap = b ? Math.max(0, b.offsetLeft - a.offsetLeft - cw) : 0;
        var unit = cw + gap;
        var fit = Math.max(1, Math.round((track.clientWidth + gap) / unit));
        return { n: Math.min(fit, cards.length), unit: unit };
      }
      function pages() {
        return Math.max(1, Math.ceil(cards.length / step().n));
      }
      function current() {
        var s = step();
        var w = s.unit * s.n;
        if (w < 2) return 0;
        return Math.max(0, Math.min(pages() - 1, Math.round(track.scrollLeft / w)));
      }
      function go(i) {
        var s = step();
        i = Math.max(0, Math.min(pages() - 1, i));
        var card = cards[Math.min(cards.length - 1, i * s.n)];
        track.scrollTo({
          left: card.offsetLeft - cards[0].offsetLeft,
          behavior: REDUCED ? 'auto' : 'smooth'
        });
      }

      /* one dot per view up to eight, a progress bar beyond that — fifty
         reviews would otherwise put seventeen dots under the carousel */
      function build() {
        if (!dots) return;
        var n = pages();
        dots.innerHTML = '';
        bar = null;
        if (n < 2) { dots.hidden = true; return; }
        dots.hidden = false;
        if (n > 8) {
          dots.className = 'revd prog';
          bar = document.createElement('i');
          bar.style.width = (100 / n) + '%';
          dots.appendChild(bar);
        } else {
          dots.className = 'revd';
          var label = dots.getAttribute('data-page') || 'Page';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', label + ' ' + (i + 1));
            dots.appendChild(b);
          }
        }
      }

      function update() {
        var n = pages(), i = current();
        if (nav) nav.hidden = n < 2;
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= n - 1;
        if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
        else if (dots) $$('button', dots).forEach(function (b, j) { b.setAttribute('aria-current', j === i); });
      }

      /* long reviews are clamped so the cards keep a common height; the
         button appears only where text is actually being cut off */
      function clamps() {
        cards.forEach(function (card) {
          if (card.classList.contains('open')) return;
          var p = $('p', card); if (!p) return;
          var btn = $('.more', card);
          var over = p.scrollHeight - p.clientHeight > 2;
          if (over && !btn) {
            btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'more';
            btn.textContent = track.getAttribute('data-more') || 'Read more';
            btn.setAttribute('aria-expanded', 'false');
            btn.addEventListener('click', function () {
              var open = card.classList.toggle('open');
              btn.textContent = track.getAttribute(open ? 'data-less' : 'data-more');
              btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            });
            p.insertAdjacentElement('afterend', btn);
          } else if (!over && btn) {
            btn.remove();
          }
        });
      }

      function pause() { if (timer) { clearInterval(timer); timer = null; } }
      function run() {
        if (stopped || !every || REDUCED || timer) return;
        timer = setInterval(function () {
          var n = pages(), i = current();
          go(i >= n - 1 ? 0 : i + 1);
        }, every);
      }
      function halt() { stopped = true; pause(); }

      if (prev) prev.addEventListener('click', function () { halt(); go(current() - 1); });
      if (next) next.addEventListener('click', function () { halt(); go(current() + 1); });
      if (dots) dots.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        halt(); go($$('button', dots).indexOf(b));
      });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { halt(); go(current() + 1); e.preventDefault(); }
        else if (e.key === 'ArrowLeft') { halt(); go(current() - 1); e.preventDefault(); }
      });

      /* drag on a mouse. Touch is left to the browser, which does it better. */
      var down = false, sx = 0, sl = 0, moved = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        if (e.target.closest('button,a')) return;
        down = true; moved = 0; sx = e.clientX; sl = track.scrollLeft;
        track.classList.add('drag');
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > moved) moved = Math.abs(dx);
        track.scrollLeft = sl - dx;
        e.preventDefault();
      });
      function endDrag() {
        if (!down) return;
        down = false;
        track.classList.remove('drag');
        if (moved > 4) { halt(); go(current()); }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      var tick = false;
      track.addEventListener('scroll', function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () { update(); tick = false; });
      }, { passive: true });

      function relayout() { build(); update(); clamps(); }
      relayout();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(clamps).catch(function () {});
      }
      if (window.ResizeObserver) new ResizeObserver(relayout).observe(track);
      else window.addEventListener('resize', relayout);

      if (every && !REDUCED) {
        root.addEventListener('pointerenter', pause);
        root.addEventListener('pointerleave', run);
        root.addEventListener('focusin', pause);
        root.addEventListener('focusout', run);
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { e.isIntersecting ? run() : pause(); });
        }, { threshold: 0.25 }).observe(track);
      }
    });
  }

  /* --------------------------------------------------- variant picker */
  function variants() {
    $$('[data-product-form]').forEach(function (form) {
      var data;
      try { data = JSON.parse($('[data-product-json]', form.closest('[data-product-root]')).textContent); }
      catch (e) { return; }
      var idField = $('[name="id"]', form);
      var priceEl = $('[data-price]', form.closest('[data-product-root]'));
      var compareEl = $('[data-compare]', form.closest('[data-product-root]'));
      var btn = $('[data-add]', form);
      var selects = $$('[data-option-index]', form.closest('[data-product-root]'));

      function current() {
        var chosen = selects.map(function (g) {
          var on = g.querySelector('[aria-current="true"], input:checked, option:checked');
          return on ? (on.value || on.getAttribute('data-value')) : null;
        });
        return data.variants.filter(function (v) {
          return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
        })[0];
      }
      function apply() {
        var v = current();
        if (!v) {
          if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable') || 'Unavailable'; }
          return;
        }
        if (idField) idField.value = v.id;
        if (priceEl) priceEl.textContent = priceFor(priceEl, v, 'price');
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = priceFor(compareEl, v, 'compare');
            compareEl.hidden = false;
          } else { compareEl.hidden = true; }
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available
            ? (btn.getAttribute('data-add-label') || 'Add to cart')
            : (btn.getAttribute('data-soldout') || 'Sold out');
        }
        if (history.replaceState && v.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url);
        }
      }
      selects.forEach(function (g) {
        g.addEventListener('click', function (e) {
          var b = e.target.closest('[data-value]'); if (!b) return;
          $$('[data-value]', g).forEach(function (x) { x.setAttribute('aria-current', x === b); });
          apply();
        });
        g.addEventListener('change', apply);
      });
      apply();
    });
  }

  /* ------------------------------------------------------ qty steppers */
  function qty() {
    $$('[data-qty]').forEach(function (w) {
      var input = $('input', w);
      $$('button', w).forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.getAttribute('data-step') === 'up' ? 1 : -1;
          var n = Math.max(parseInt(input.getAttribute('data-min') || '1', 10), (parseInt(input.value, 10) || 1) + d);
          input.value = n;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* -------------------------------------------------- add to cart (ajax) */
  function bumpCount(by) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = (parseInt(el.textContent, 10) || 0) + by;
    });
  }
  function ajaxAdd() {
    $$('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;              // no fetch: let the form post normally
        e.preventDefault();
        var btn = $('[data-add]', form);
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || 'Adding…'; }
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (item) {
            bumpCount(item.quantity || 1);
            announce((item.product_title || 'Item') + ' added to your cart');
            if (btn) { btn.textContent = btn.getAttribute('data-added') || 'Added'; }
            setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1400);
          })
          .catch(function () { form.submit(); });
      });
    });
  }

  /* ------------------------------------------------- cart line updates */
  function cartLines() {
    var root = $('[data-cart]'); if (!root) return;
    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]'); if (!input) return;
      update(input.getAttribute('data-line'), input.value);
    });
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]'); if (!rm) return;
      e.preventDefault();
      update(rm.getAttribute('data-line'), 0);
    });
    function update(line, quantity) {
      root.setAttribute('aria-busy', 'true');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }
  }

  /* ---------------------------------------------------------- init */
  function init() {
    reveals(); chrome(); spins(); mediaTabs(); gallery(); films(); reviews();
    variants(); qty(); ajaxAdd(); cartLines();
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  /* the theme editor tears sections down and rebuilds them */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', reveals);

  /* selecting a review block in the editor should bring it into view — with
     fifty of them most are off to the side of the track */
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.rev') : null;
    if (!card) return;
    var track = card.parentNode;
    if (!track || !track.hasAttribute('data-rev-track') || !track.firstElementChild) return;
    track.scrollTo({ left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'smooth' });
  });
})();
